export default "__VITE_ASSET__DK_dPHab__"